(function () {
  'use strict';

  /* ??? Defaults ??????????????????????????????????????????????? */
  const DEFAULTS = {
    maxProducts: 8,
    fallbackCollection: 'all',
    showVendor: false,
    showRating: false,
    showComparePrice: true,
    enabled: true,
    heading: 'You May Also Like',
  };

  let swiperInstance    = null;
  let currentProductIds = null;  
  let isFetching        = false;
  let cfg               = null;
  let domObserver       = null;
  let cartObserver      = null;
  let isCartUpdating    = false;

  /* ???????????????????????????????????????????????????????????????
   * INIT
   * ??????????????????????????????????????????????????????????????? */
  function init() {
    const section = document.getElementById('cart-upsell-section');
    section.style.display = 'none';
    if (!section) return;

    cfg = readConfig(section);

    if (!cfg.enabled) {
      section.classList.add('cart-upsell--hidden');
      return;
    }

    watchCartMutations();
    watchForShellReplacement();
    hookFetchInterceptor();
    hookCurrencyChange();

    document.addEventListener('wdt:cart:changed', (e) => {
    if (e.detail?.removed) {
        currentProductIds = null;
        refresh(true);
    }
    });

    if (document.querySelector('#wdtCartOffcanvas.show')) {
      refresh(false);
    }
  }

  function readConfig(el) {
    const d = el.dataset;
    return {
    enabled: d.enabled !== 'false',
    maxProducts: parseInt(d.maxProducts, 10) || DEFAULTS.maxProducts,
    fallbackCollection: d.fallbackCollection || DEFAULTS.fallbackCollection,
    upsellSource: d.upsellSource || 'related',
    showVendor: d.showVendor === 'true',
    showRating: d.showRating === 'true',
    showComparePrice: d.showComparePrice !== 'false',
    heading: d.heading || DEFAULTS.heading,
};
  }

 
window.cartUpsellRestore = function(cartDrawer) {
  injectUpsellShell(cartDrawer);
  const section = document.getElementById('cart-upsell-section');
  if (!section) return;
  cfg = readConfig(section);
  watchCartMutations();
  hookFetchInterceptor();
  hookCurrencyChange();
};

window.cartUpsellRefresh = function() {
  const shellMissing = !document.getElementById('cart-upsell-section');
  if (shellMissing) {
    currentProductIds = null;
  }
  refresh(false);
};

 function hookFetchInterceptor() {
  if (window.__cartUpsellFetchHooked) return;

  window.__cartUpsellFetchHooked = true;

  const originalFetch = window.fetch;

  window.fetch = function (...args) {

    let url = '';

    if (typeof args[0] === 'string') {
      url = args[0];
    } else if (args[0] instanceof Request) {
      url = args[0].url;
    } else if (args[0]?.url) {
      url = args[0].url;
    }

   if (url.includes('/cart/update')) {
  console.group('UPDATE REQUEST');

  try {
    console.log(
      'BODY JSON:',
      JSON.parse(args[1]?.body || '{}')
    );
  } catch(e) {}

  console.groupEnd();
}


    return originalFetch.apply(this, args)
      .then(async response => {

        return response;
      });
  };
}

  
  function hookCurrencyChange() {

    document.addEventListener('shopify:currency_selected', (e) => {
      const section = document.getElementById('cart-upsell-section');
      if (section && cfg) {
        cfg.shopCurrency = section.dataset.shopCurrency || null;
      }
      setTimeout(() => {
        destroySwiper();
        if (!section) return;
        refresh(false);
      }, 100);
    });

    const currencySelector = document.querySelector('[data-currency-selector], .localization-form__select, [id*="currency"]');
    if (currencySelector) {
      const obs = new MutationObserver(() => {
        destroySwiper();
        setTimeout(() => refresh(false), 100);
      });
      obs.observe(currencySelector, { attributes: true, subtree: true });
    }
  }
 
 function watchCartMutations() {
  if (cartObserver) cartObserver.disconnect();

  const attach = () => {
    const el = document.getElementById('wdtItemsList');
    if (!el) return;
    cartObserver = new MutationObserver(() => {

       if (isCartUpdating) {
  clearTimeout(cartObserver._retry);

  cartObserver._retry = setTimeout(() => {
    refresh(true);
  }, 500);

  return;
}
      clearTimeout(cartObserver._t);
      cartObserver._t = setTimeout(async () => {
        try {
          const res = await fetch('/cart.js', { cache: 'no-store' });
          const cart = await res.json();

          if (!cart.items.length) {
            const section = document.getElementById('cart-upsell-section');

            if (section) {
              section.classList.add('cart-upsell-loading');
              section.classList.add('cart-upsell--hidden');

              const wrapper = section.querySelector('.cart-upsell__slider-wrap');
              if (wrapper) wrapper.innerHTML = '';
            }

            destroySwiper();
            currentProductIds = '';
            return;
          }
          const { productIds } = extractCartData(cart);
          const idsString = productIds.sort().join(',');
          
          // if (idsString !== currentProductIds) {
          //   currentProductIds = null;
          //   refresh(true);
          // }
        } catch {
        }
      }, 400);
    });
    cartObserver.observe(el, { childList: true, subtree: true });
  };

  attach();
  setTimeout(attach, 500);
}

  function watchForShellReplacement() {
  if (domObserver) domObserver.disconnect();
  const cartDrawer = document.getElementById('wdtCartOffcanvas');
  if (!cartDrawer) return;

  domObserver = new MutationObserver(() => {
    if (!document.getElementById('cart-upsell-section')) {
      injectUpsellShell(cartDrawer);
      reinit();
    }
  });
  domObserver.observe(cartDrawer, { childList: true, subtree: false });
}

  function injectUpsellShell(cartDrawer) {
    const c   = window.cartUpsellConfig || {};
    const div = document.createElement('div');
    div.id        = 'cart-upsell-section';
    div.className = 'cart-upsell';
    Object.assign(div.dataset, {
      enabled:            String(c.enabled          ?? true),
      maxProducts:        String(c.maxProducts       ?? 8),
      fallbackCollection: String(c.fallbackCollection ?? 'all'),
      showVendor:         String(c.showVendor        ?? false),
      showRating:         String(c.showRating        ?? false),
      showComparePrice:   String(c.showComparePrice  ?? true),
      heading:            String(c.heading           ?? 'You May Also Like'),
    });
    const h = div.dataset.heading;
    const widget =
    cartDrawer.querySelector('#wdtItemsWrap') ||
    cartDrawer.querySelector('#wdtCartBody') ||
    cartDrawer;

    widget.appendChild(div);
  }

  function reinit() {
    swiperInstance    = null;
    currentProductIds = null;
    cfg               = null;
    const section     = document.getElementById('cart-upsell-section');
    if (!section) return;
    cfg = readConfig(section);
    watchCartMutations();
    watchForShellReplacement();
    hookFetchInterceptor();
    hookCurrencyChange();
    refresh(true);
  }

  /* ???????????????????????????????????????????????????????????????
   * REFRESH PIPELINE
   * ??????????????????????????????????????????????????????????????? */
  async function refresh(force) {

        if (isFetching) {
   
    return;
}
    isFetching = true;

    const section = document.getElementById('cart-upsell-section');
// if (section) {
//     section.style.display = '';
//     section.classList.add('cart-upsell-loading');
//     showSkeleton();
// }

if (section) {
    section.classList.add('cart-upsell-loading');
}
    try {
      const cart = await fetchCart();

      const cartCount = cart.item_count || 0;
      const { productIds } = extractCartData(cart);
      const idsString = productIds.sort().join(',');

      if (!force && idsString === currentProductIds) {
      return;
    }

      currentProductIds = idsString;

      if (!cart.items.length) {

    const section = document.getElementById('cart-upsell-section');

    if (section) {
        hideSkeleton();
        destroySwiper();

        section.classList.add('cart-upsell--hidden');

        const wrapper = section.querySelector('.cart-upsell__slider-wrap');
        if (wrapper) {
            wrapper.innerHTML = '';
        }
    }

    currentProductIds = '';
    return;
}

      
      const products = await getRecommendations(cart);
      if (products.length && section) {
          section.style.display = '';
          showSkeleton();
      }

     if (!products.length) {
          section.style.display = 'none';
          return;
      }

      section.classList.remove('cart-upsell--hidden');
      section.style.display = '';
      await renderSlider(products);
      currentProductIds = idsString;
    } catch (err) {
      console.warn('[CartUpsell]', err);
      hideSkeleton();
    } finally {
    isFetching = false;

    if (section) {
        section.classList.remove('cart-upsell-loading');
    }
}
  }

  /* ???????????????????????????????????????????????????????????????
   * CART DATA
   * ??????????????????????????????????????????????????????????????? */
  async function fetchCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }
  function extractCartData(cart) {
    return {
      productIds: [...new Set(cart.items.map(i => i.product_id))],
    };
  }

  async function getRecommendations(cart) {
    const { productIds } = extractCartData(cart);

    if (!productIds.length) return [];

    const max = cfg.maxProducts;
    const exclude = new Set(productIds.map(String));

    let products = [];

    switch (cfg.upsellSource) {

        case 'related':
            products = await fetchRelated(productIds[0], max);
            break;

        case 'complementary':
            products = await fetchComplementary(productIds[0], max);
            break;

        case 'fallback':
            products = await fetchFallbackCollection(cfg.fallbackCollection, max);
            break;

        default:
            console.warn('[CartUpsell] Unknown source:', cfg.upsellSource);
            return [];
    }

    return products
        .filter(product => !exclude.has(String(product.id)))
        .slice(0, max);
}

  /* ?? Fetch helpers ??????????????????????????????????????????? */

  /** P1 - Search & Discovery complementary intent */
  async function fetchComplementary(productId, limit) {
    if (!productId) return [];
    try {
      const res = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=complementary`
      );
      if (!res.ok) return [];
      const { products = [] } = await res.json();
      return products.filter(p => p.available);
    } catch (err) {
      console.warn('[CartUpsell] fetchComplementary error:', err);
      return [];
    }
  }

  /** P2 - Search & Discovery related intent */
  async function fetchRelated(productId, limit) {
    if (!productId) return [];
    try {
      const res = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`
      );
      if (!res.ok) return [];
      const { products = [] } = await res.json();
      return products.filter(p => p.available);
    } catch (err) {
      console.warn('[CartUpsell] fetchRelated error:', err);
      return [];
    }
  }

  /** P3 - Best-selling products from fallback collection (theme settings) */
  async function fetchFallbackCollection(handle, limit) {
    if (!handle) {
      console.warn('[CartUpsell] Fallback collection handle is empty');
      return [];
    }
    try {
      const res = await fetch(
        `/collections/${handle}/products.json?limit=${limit}&sort_by=best-selling`
      );
      if (!res.ok) {
        console.warn('[CartUpsell] Fallback collection fetch failed:', res.status);
        return [];
      }
      const { products = [] } = await res.json();

      const available = products.filter(product =>
        product.variants?.some(variant => variant.available)
      );
      return available;
    } catch (err) {
      console.warn('[CartUpsell] fetchFallbackCollection error:', err);
      return [];
    }
  }

  /* ???????????????????????????????????????????????????????????????
   * RENDERING
   * ??????????????????????????????????????????????????????????????? */
  async function renderSlider(products) {


    const section = document.getElementById('cart-upsell-section');


    if (!section) return;

    destroySwiper();
    hideSkeleton();

    if (!products || !products.length) {
    const wrapper = section.querySelector('.cart-upsell__slider-wrap');

      if (wrapper) {
          wrapper.innerHTML = '';
      }

      section.classList.add('cart-upsell--hidden');
      return;
  }

    const wrapper = section.querySelector('.cart-upsell__slider-wrap');

    if (!wrapper) return;


    section.classList.remove('cart-upsell--hidden');
    wrapper.innerHTML = `<div class="swiper"><div class="swiper-wrapper">${
      products.map(buildProductCard).join('')
    }</div></div>`;
    

    await waitForSwiper();

    if (window.Swiper) {
      swiperInstance = new window.Swiper(wrapper.querySelector('.swiper'), {
        slidesPerView: 1,
        spaceBetween: 12,
        grabCursor: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          768:  { slidesPerView: 1 },
          1200: { slidesPerView: 1 },
        },
        a11y: {
          prevSlideMessage: 'Previous product',
          nextSlideMessage: 'Next product',
        },
      });
    }

    section.querySelectorAll('.cart-upsell-card__add').forEach(btn => {
        btn.addEventListener('click', handleQuickAdd);
      });
  }

  function waitForSwiper(maxWait = 4000) {
    if (window.Swiper) return Promise.resolve();
    return new Promise(resolve => {
      const t0 = Date.now();
      (function check() {
        if (window.Swiper || Date.now() - t0 > maxWait) return resolve();
        setTimeout(check, 80);
      })();
    });
  }

  

  function buildProductCard(product) {
    const variants = product.variants || [];
    const variant  = variants.find(v => v.available) || variants[0] || {};
    const price   = formatMoney(variant.price);
    const compare = cfg.showComparePrice && variant.compare_at_price > variant.price
                      ? formatMoney(variant.compare_at_price) : null;


    let rawImg =
      product.featured_image?.src ||
      product.featured_image ||
      product.images?.[0]?.src ||
      product.images?.[0] ||
      product.media?.[0]?.preview_image?.src ||
      '';
    if (rawImg && typeof rawImg === 'object') rawImg = rawImg.src || '';
    const sep   = rawImg.includes('?') ? '&' : '?';
    const image = rawImg
      ? rawImg.replace(/[?&]width=\d+/, '') + sep + 'width=400'
      : null;

    const available   = variant.available !== false;
    const saleCls     = compare ? ' cart-upsell-card__price--sale' : '';
    const vendorHtml  = cfg.showVendor && product.vendor
                          ? `<p class="cart-upsell-card__vendor">${escHtml(product.vendor)}</p>` : '';
    const compareHtml = compare
                          ? `<s class="cart-upsell-card__price--compare original-price">${compare}</s>` : '';
                          

    return `
      <div class="swiper-slide">
        <div class="cart-upsell-card">
          <div class="cart_upsell_img border rounded-3">
        <a href="/products/${escHtml(product.handle)}" class="cart-upsell-card__image-wrap" aria-hidden="true">
          ${image
            ? `<img class="cart-upsell-card__image" src="${escAttr(image)}" alt="${escAttr(product.title)}" width="400" height="400" loading="lazy">`
            : `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5" style="height: 100%;width: 100%;">
                <path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z">
                </path>
                </svg>`
          }
        </a>
          </div>
          <div class="cart-upsell-card__body d-flex flex-column justify-content-center gap-2">
            ${vendorHtml}
            <h5 class="cart-upsell-title m-0">
             <a href="/products/${escHtml(product.handle)}" class="cart-upsell-card__title text-decoration-none">${escHtml(product.title)}</a>
            </h5>
            <div class="cart-upsell-card__price-wrap price">
              <span class="cart-upsell-card__price${saleCls}">${price}</span>
              ${compareHtml}
            </div>
            ${!available ? `
              <span class="bg-transparent border-0 btn-link cart-upsell-card__add p-0 text-start disabled">
                Sold out
              </span>
            ` : variants.length > 1 ? `
              <a href="/products/${escHtml(product.handle)}"
                class="bg-transparent border-0 btn-link cart-upsell-card__select p-0 text-start"
                aria-label="Select options for ${escAttr(product.title)}">
                Select options
              </a>
            ` : `
              <a href="#"
                class="bg-transparent border-0 btn-link cart-upsell-card__add p-0 text-start"
                data-variant-id="${variant.id}"
                data-product-id="${product.id}"
                aria-label="Add ${escAttr(product.title)} to cart">
                Add to cart
              </a>
            `}
          </div>
        </div>
      </div>`;
  }


  /* ???????????????????????????????????????????????????????????????
   * QUICK-ADD
   * ??????????????????????????????????????????????????????????????? */
 async function handleQuickAdd(e) {
  e.preventDefault();
  e.stopPropagation();

  const btn = e.currentTarget;
  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    if (!response.ok) throw new Error('Add failed');
    if (typeof window.fetchCart === 'function') {
      window.fetchCart();
    }

    if (typeof window.showCartDrawer === 'function') {
      window.showCartDrawer();
    }

    setTimeout(() => {
      window.cartUpsellRefresh?.();
    }, 500);

    setTimeout(() => {
      btn.disabled = false;
      btn.textContent = 'Add to cart';
    }, 2000);

  } catch (err) {
    console.error('[CartUpsell]', err);
    btn.disabled = false;
    btn.textContent = 'Try again';
  }
}

function showSkeleton() {
  const section = document.getElementById('cart-upsell-section');
  if (!section) return;

  const wrapper = section.querySelector('.cart-upsell__slider-wrap');
  if (!wrapper) return;

  wrapper.innerHTML = `
    <div class="swiper">
      <div class="swiper-wrapper">
        ${Array.from({ length: 3 }).map(() => `
          <div class="swiper-slide">
            <div class="cart-upsell-card placeholder-glow">
              <div class="cart_upsell_img border rounded-3">
                <div class="placeholder w-100" style="aspect-ratio:1;"></div>
              </div>

              <div class="cart-upsell-card__body d-flex flex-column justify-content-center gap-2">
                <span class="placeholder col-8"></span>
                <span class="placeholder col-5"></span>
                <span class="placeholder col-4"></span>
                <span class="placeholder btn btn-sm disabled col-5"></span>
              </div>
            </div>
          </div>
        `).join('')}
      </div>
    </div>
  `;
}

  function hideSkeleton() {
  const wrapper = document.querySelector('#cart-upsell-section .cart-upsell__slider-wrap');
  if (wrapper) wrapper.innerHTML = '';
}

  /* ???????????????????????????????????????????????????????????????
   * SWIPER
   * ??????????????????????????????????????????????????????????????? */
  function destroySwiper() {
    if (swiperInstance) {
      try { swiperInstance.destroy(true, true); } catch {}
      swiperInstance = null;
    }
  }

  /* ???????????????????????????????????????????????????????????????
   * UTILITIES
   * ??????????????????????????????????????????????????????????????? */
    function formatMoney(cents) {
      if (cents == null) return '';

      const moneyFormat =
        window.DT_THEME?.moneyFormat ||
        window.wdtTheme?.moneyFormat ||
        window.theme?.moneyFormat ||
        window.Shopify?.money_format ||
        '${{amount}}';

      if (window.Shopify?.formatMoney) {
        // If an active currency differs from shop currency, try converter
        const shopCurrency  = cfg?.shopCurrency || window.Shopify?.currency?.active;
        const activeCurrency = window.Shopify?.currency?.active;

        if (
          activeCurrency &&
          shopCurrency &&
          activeCurrency !== shopCurrency &&
          typeof window.Currency?.convert === 'function'
        ) {
          const converted = window.Currency.convert(cents, shopCurrency, activeCurrency);
          return window.Shopify.formatMoney(converted, moneyFormat);
        }

        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      return (cents / 100).toFixed(2);
    }
  function escHtml(s) {
    return String(s ?? '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function escAttr(s) { return String(s ?? '').replace(/"/g,'&quot;'); }

  /* ??? Boot ??? */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

